module.exports = __webpack_public_path__ + "static/two_outside_660-7722fa1ea3974b58b3ee7942c1188046.jpg";